module.exports = __webpack_public_path__ + "img/cpp.7aca2586.png";